/*
|
|               Calculation
_______________________________________________
|
|    This class keep all fields for 
|    calculation. Using for proposal and
|    breakdown tabs, to show full data
|    about project order info
|
*/

export class Calculation {
    all_savings                     :any     = 'N/A';
    amortized_savings               :any     = 'N/A';
    due_total                       :any     = 'N/A';
    economy                         :any     = 'N/A';
    existing_kWhs                   :any     = 'N/A';
    existing_kWhs_number            :number  = 0;
    epact_tax                       :any     = 'N/A';
    full_savings                    :any     = 'N/A';
    hvac                            :any     = 'N/A';
    hvac_kWh                        :any     = 'N/A';
    investments                     :any     = 'N/A';
    InstallationCost                :any     = 'N/A';
    lamps_number                    :any     = 'N/A';
    lamps_price                     :any     = 'N/A';
    led_life                        :any     = 'N/A';
    lifetime                        :any     = 'N/A';
    lifetime_maint_savings          :any     = 'N/A';
    lifetime_savings                :any     = 'N/A';
    lifetime_savings_kWt            :any     = 'N/A';
    lifetime_kWh_existing           :any     = 'N/A';
    lifetime_kWh_proposed           :any     = 'N/A';
    lifetime_kWh_existing_number    :number  = 0;
    lifetime_kWh_proposed_number    :number  = 0;
    monthly_savings                 :any     = 'N/A';
    old_life                        :any     = 'N/A';
    payback_time                    :any     = 'N/A';
    productCost                     :any     = 'N/A';
    product_list_by_zones?          :any     = [];
    product_list : any = {
      existing: [],
      proposed: []
    };
    proposed_kWhs                   :any     = 'N/A';
    proposed_kWhs_number            :number  = 0;
    rebates                         :any     = 'N/A';
    shippingCost                    :any     = 'N/A';
    tax                             :any     = 8.650;
    tax_amount                      :any     = 'N/A';
    total_amount                    :any     = 'N/A';
    total_amount_number             :number  = 0;
    total_cost                      :any     = 'N/A';
    total_cost_number               :any     = 'N/A';
    total_after_rebates             :any     = 'N/A';
    roi                             :any     = 'N/A';
    usage                           :any     = 'N/A';
    watt_price                      :any     = 'N/A';
    wattage                         :any     = 'N/A';
    years_energy_maint              :any     = 'N/A';
    all_options                     :any     = [];
    A                               :any     = [];
    B                               :any     = [];
    C                               :any     = [];
}



// WEBPACK FOOTER //
// /root/anvel/angular/classes/Calculations.ts